import {
  FAILED_GET_REGION,
  FAILED_PERSIST_REGION,
  RECEIVE_GET_REGION,
  RECEIVE_GET_REGIONS,
  RECEIVE_PERSIST_REGION,
  REQUEST_PERSIST_REGION,
} from 'common/redux/actions/region'
import { RESET_STATE } from 'common/redux/actions/global'

const initialState = {
  form: {
    data: {},
    error: '',
    fetching: true,
    sending: false,
    deleting: false,
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0,
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_REGION:
    case FAILED_PERSIST_REGION:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        },
      }
    case RECEIVE_PERSIST_REGION:
    case RECEIVE_GET_REGION:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
          sending: false,
        },
      }
    case RECEIVE_GET_REGIONS:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
          pageNumber: action.pageNumber,
          totalCount: action.totalCount,
        },
      }
    case REQUEST_PERSIST_REGION:
      return {
        ...state,
        form: {
          ...state.form,
          sending: true,
        },
      }

    case RESET_STATE:
      if (action.state === 'region') {
        return {
          ...state,
          [action.screen]: initialState[action.screen],
        }
      }

      return state
    default:
      return state
  }
}
